import API from "helpers/api";
import { Apis } from "services/api";

// Thin axios wrappers around the EMI3-1288 backend at /api/report-subscriptions.
// Mappers between the backend ReportSubscriptionDto and the UI view-model live
// alongside in mapping.js so the components stay free of API shape concerns.
//
// Note: we don't use the shared getAPIResponse helper here because it only
// treats 200/201 as success. The subscription endpoints also return 202
// (run-now) and 204 (delete), so we accept any 2xx as success.

const ok = (response) => ({
	status: response?.status >= 200 && response?.status < 300,
	data: response?.data,
});

export const listReportSubscriptions = async () => {
	try {
		return ok(await API.get(Apis.ReportSubscriptions));
	} catch (err) {
		return ok(err?.response);
	}
};

export const createReportSubscription = async (body) => {
	try {
		return ok(await API.post(Apis.ReportSubscriptions, body));
	} catch (err) {
		return ok(err?.response);
	}
};

export const updateReportSubscription = async (id, body) => {
	try {
		return ok(await API.put(`${Apis.ReportSubscriptions}/${id}`, body));
	} catch (err) {
		return ok(err?.response);
	}
};

export const toggleReportSubscription = async (id, isActive) => {
	try {
		return ok(
			await API.patch(`${Apis.ReportSubscriptions}/${id}/toggle`, { isActive })
		);
	} catch (err) {
		return ok(err?.response);
	}
};

export const deleteReportSubscription = async (id) => {
	try {
		return ok(await API.delete(`${Apis.ReportSubscriptions}/${id}`));
	} catch (err) {
		return ok(err?.response);
	}
};

export const runReportSubscription = async (id) => {
	try {
		return ok(await API.post(`${Apis.ReportSubscriptions}/${id}/run`));
	} catch (err) {
		return ok(err?.response);
	}
};
